import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useState } from "react";
import ModalDefault from "../../../components/modalDefault";
import { buildCodigoReporte } from "../../../utils/date";
dayjs.extend(isSameOrBefore);

export default function ModalInactivos({
  showResumen,
  setShowResumen,
  comidasFiltered,
  buildResumen,
  exportToExcelRecuento,
  setResumenData,
  resumenData,
}) {
  const [showCodigos, setShowCodigos] = useState(false);
  const [codigosReporte, setCodigosReporte] = useState([]);

  const handleViewCodigos = (code) => {
    const filteredCodigos = comidasFiltered.filter(
      (item) => item.pre_usuarios.code === code
    );
    setCodigosReporte(filteredCodigos);
    setShowCodigos(true);
  };

  return (
    <>
      <ModalDefault
        modal={showResumen}
        size="lg"
        titulo="Tickets usuarios inactivos/eliminados"
        closeAction={() => setShowResumen(false)}
      >
        <div className="table-responsive" style={{ maxHeight: "400px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <input
              type="search"
              className="form-control w-50 my-2 mx-2"
              placeholder="Buscar por código..."
              onChange={(e) => {
                const searchTerm = e.target.value.toLowerCase();
                const filteredData = buildResumen(comidasFiltered)?.filter(
                  (item) => item.code.toString().toLowerCase() === searchTerm
                );
                setResumenData(filteredData);
                if (searchTerm === "") {
                  setResumenData(buildResumen(comidasFiltered));
                }
              }}
            />
            <button
              type="button"
              className="bg-btn-vet bordesombreado my-2 mx-2 d-flex"
              onClick={() => {
                exportToExcelRecuento();
              }}
            >
              <i className="fas fa-file-excel mx-2"></i>
              Exportar Excel
            </button>
          </div>
          <table className="table table-striped table-bordered mb-0">
            <thead className="text-center">
              <tr>
                <th>Código Trabajador</th>
                <th>Nombres - Apellidos</th>
                <th>Cantidad Tickets</th>
                <th>Código Reporte</th>
              </tr>
            </thead>
            <tbody>
              {resumenData.map(({ code, count, sample, nombres }) => (
                <tr key={code}>
                  <td className="text-center">
                    {code.toString().padStart(4, "0")}
                  </td>
                  <td className="text-center">{nombres}</td>

                  <td className="text-center">{count}</td>

                  <td className="text-center d-flex gap-2 justify-content-center">
                    {`${code.toString().padStart(4, "0")}${dayjs(
                      sample.create_at
                    ).format("YYYYMMDDHHmmss")}4008`}
                    <button
                      onClick={() => handleViewCodigos(code)}
                      className="d-flex justify-content-center align-items-center p-1"
                      style={{ background: "none", borderRadius: "5px" }}
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ModalDefault>
      <ModalDefault
        modal={showCodigos}
        size="lg"
        titulo="Codigos de Reporte"
        closeAction={() => setShowCodigos(false)}
      >
        <div className="table-responsive" style={{ maxHeight: "400px" }}>
          <table className="table table-striped table-bordered mb-0">
            <thead className="text-center">
              <tr>
                <th>#</th>
                <th>Código Reporte</th>
              </tr>
            </thead>
            <tbody>
              {codigosReporte.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{buildCodigoReporte(item)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ModalDefault>
    </>
  );
}
